import React from 'react';
import ChargerTasksSSPList from '../../../common/components/ChargerTasksSSPList';

function TasksTab(props) {
  const { isMobile, isModal } = props;
  const wrapperClassName = `create-edit-static-list${isMobile ? ' mobile' : ''}${isModal ? ' modal' : ''}`;

  return (
    <div className={wrapperClassName}>
      <ChargerTasksSSPList {...props} />
    </div>
  );
}

export default TasksTab;
